import { render, staticRenderFns } from "./QPopupDataTable.vue?vue&type=template&id=12770a86&scoped=true&"
import script from "./QPopupDataTable.vue?vue&type=script&lang=js&"
export * from "./QPopupDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QPopupDataTable.vue?vue&type=style&index=0&id=12770a86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12770a86",
  null
  
)

export default component.exports